// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2242":"css/app.7026","8765":"css/admin-app.7026"}[chunkId] + ".css";
};